import React, { useState, useImperativeHandle, forwardRef } from "react";
import "./index.css";
import { createSubstring } from "../../../mail/utils";

const MobileBoxesDrawer = forwardRef(({ redirectToFoldersPage, boxes, setCurrentBox, currentBox }, ref) => {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const openDrawer = () => setIsNavOpen(true);
    const closeDrawer = () => setIsNavOpen(false);

    useImperativeHandle(ref, () => ({
        openDrawer,
        closeDrawer,
    }));

    return (
        <div className={`mobile-nav-container d-block d-md-none ${isNavOpen ? "open" : ""}`}>
            {/* Overlay that dims background and closes on click */}
            <div className="mobile-nav-overlay" onClick={closeDrawer}></div>

            {/* The actual drawer */}
            <div className="mobile-nav-content">
                <div className="drawer-header p-3 d-flex justify-content-between align-items-center border-bottom">
                    <h5 className="mb-0">Folders</h5>
                    <i
                        className="fa-solid fa-xmark"
                        style={{ fontSize: "24px", cursor: "pointer" }}
                        onClick={closeDrawer}
                    />

                </div>

                <div className="p-3">
                    <button onClick={redirectToFoldersPage} className="btn btn-sm btn-primary mb-3 w-100">Manage Folders</button>
                    <ul className="list-unstyled m-0">
                        {boxes.map((box) => (
                            <li
                                key={box.name}
                                id={box.name}
                                className={`mb-2 p-2 ${box.name === currentBox ? "highlighted" : "customLi"}`}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setCurrentBox(box.name);
                                    closeDrawer();
                                }}
                            >
                                {createSubstring(box.name, 10)}
                                {box.totalUnread > 0 && (
                                    <strong className="ms-2">({box.totalUnread})</strong>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
});

export default MobileBoxesDrawer;
